import { RJSFSchema } from '@rjsf/utils';
import {
  KnownKioskBrandingDtoPoweredByTheme,
  KnownKioskBrandingLogoDtoType
} from '@groundfloor-platform/mgmt-service-g-sdk';

const themeZone = {
  type: 'string' as const,
  oneOf: [
    { type: 'string' as const, title: 'Light content on dark', enum: ['dark'] },
    { type: 'string' as const, title: 'Dark content on light', enum: ['light'] }
  ]
};

export const kioskThemeSettingsFormSchema: RJSFSchema = {
  properties: {
    themeHome: { ...themeZone, title: 'Base style for home' },
    themeOtherScreens: { ...themeZone, title: 'Base style for other screens' },
    themeHomeFooter: { ...themeZone, title: 'Home footer' },
    themeSessionFooter: { ...themeZone, title: 'Session footer' },

    logoType: {
      type: 'string',
      title: 'Main logo',
      oneOf: [
        { type: 'string' as const, title: 'None', enum: [KnownKioskBrandingLogoDtoType.None] },
        { type: 'string' as const, title: 'Default (Groundfloor)', enum: [KnownKioskBrandingLogoDtoType.Default] },
        { type: 'string' as const, title: 'Custom', enum: [KnownKioskBrandingLogoDtoType.Branded] }
      ]
    },
    logoSrc: { type: 'string', title: 'Logo file' },
    logoHomeScreenHeightPx: { type: 'number', title: 'Logo height (px)' },
    logoHomeScreenPositionYPx: { type: 'number', title: 'Distance from top (px)' },
    poweredByTheme: {
      type: 'string',
      title: 'Powered by logo',
      oneOf: [
        { type: 'string' as const, title: 'Groundfloor Mono', enum: [KnownKioskBrandingDtoPoweredByTheme.Mono] },
        { type: 'string' as const, title: 'LastK Mono', enum: [KnownKioskBrandingDtoPoweredByTheme.LastkMono] },
        { type: 'string' as const, title: 'LastK', enum: [KnownKioskBrandingDtoPoweredByTheme.Lastk] },
        { type: 'string' as const, title: 'Hidden', enum: [KnownKioskBrandingDtoPoweredByTheme.Hidden] }
      ]
    },

    backgroundHome: { type: 'string', title: 'Home background image' },
    backgroundSession: { type: 'string', title: 'Other screens background image' },

    colorsLightPrimary: { type: 'string', title: 'Primary buttons' },
    colorsLightPrimaryVariant: { type: 'string', title: 'Primary highlight' },
    colorsLightOnPrimary: { type: 'string', title: 'Text on primary' },
    colorsLightOnSecondary: { type: 'string', title: 'Secondary button text & border' },

    colorsDarkPrimary: { type: 'string', title: 'Primary buttons' },
    colorsDarkPrimaryVariant: { type: 'string', title: 'Primary highlight' },
    colorsDarkOnPrimary: { type: 'string', title: 'Text on primary' },
    colorsDarkOnSecondary: { type: 'string', title: 'Secondary button text & border' }
  },
  required: ['themeHome', 'themeOtherScreens', 'themeHomeFooter', 'themeSessionFooter']
};
